import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text, Localizer, withText } from 'preact-i18n';
import Markdown from 'preact-markdown';

import localUtil from '../../lib/util';
import fields from '../../lib/fields';

import FormFields from '../../components/form/fields';
import Input from '../../components/form/input';
import DyrejournalSaleSearch from '../../components/dyrejournal/search';
import DyrejournalJournalListMini from '../../components/dyrejournal/listJournalMini';

@withText(props => ({
    orderNumber: <Text id='input.orderNumber-help'>orderNumber</Text>,
    name: <Text id='input.name-help'>name</Text>,
    description: <Text id='input.description-help'>description</Text>,
    installation: <Text id='input.installation-help'>installation</Text>,
    url: <Text id='input.url-help'>url</Text>,
    journalTitle: <Text id='dyrejournal.journal.search-title'>Search for journals</Text>,
}))
@observer
class NewProduct extends Component {
  	constructor(props) {
        super(props);
        this.state = {
            sections: fields.get('product'),
        };
    }

    createProduct = async () => {
        const { callback = () => {} } = this.props;
        const { productStore, appState } = this.props.stores;
        const { currentCustomer = {}, inputProps = {} } = appState;
        const { showFrontpageShop } = inputProps;
        // if (showFrontpageShop) {
        //     productStore.updateObjectKeyValue('newProduct', 'customer', currentCustomer?.id);
        // }

        const { newProduct } = productStore;
        const response = await productStore.insert(newProduct);
        const product = response?.data?.product;
        productStore.updateKeyValue('newProduct', {});
        if (response.status === 201) {
            callback(product);
        }
    }

    loadAll = async () => {
        const { id, isNew } = this.props;
        const { productStore } = this.props.stores;
        if (!isNew) {
            // await productStore.load(id, null, { addData: ['allProducts'] });
            await productStore.load(id, null);
            const { product } = productStore;
            this.loadJournals(product.journal);
        }
    }

    loadJournals = async id => {
        const { productStore, journalStore } = this.props.stores;
        if (id) {
            const query = {
                id,
            };
            const response = await journalStore.load({
                query,
                skipUpdate: true,
            });
            productStore.updateKeyValue('productJournals', response);
        } else {
            productStore.updateKeyValue('productJournals', []);
        }
    }

    searchJournalCallback = async (item) => {
        const { productStore } = this.props.stores;
        const { product } = productStore;
        // console.log('searchJournalCallback', item);
        if (item?.id) {
            console.log('updating journal', item.id, product.id);
            productStore.saveField(product.id, 'journal', item.id, true);
            this.loadJournals(item.id);
        }
        // saleStore.updateKeyValue('isProductionAnimals', isProductionAnimals);
    }

    componentDidMount() {
        this.loadAll();
    }

    render() {
        const { journalTitle } = this.props;
        const { week, isNew, hideAdmin, drawerLevel } = this.props;
        const { sections } = this.state;
        const { userStore, productStore, journalStore } = this.props.stores;
        const { user, isAdmin, isCustomerAdmin } = userStore;
        const { newProduct, product, productJournals } = productStore;
        const darkmode= util.getNestedValue(user, 'settings.darkmode');

        if (!isCustomerAdmin) {
            return (<>
                <div class='w-100 d-flex justify-content-center'>
                    <div class='w-100' style='max-width: 960px; padding-top: 20px; padding-bottom: 100px;'>
                        <div class='w-100 d-flex flex-column justify-content-start'>
                            <div class='font-weight-lighter px-3 box-header mt-0'>
                                <Text id='product.noAccess'>You do not have access to this page.</Text>
                            </div>
                        </div>
                    </div>
                </div>
            </>)
        }

        return (<>
            <div class='w-100 d-flex justify-content-center'>
                <div class='w-100' style='max-width: 960px; padding-top: 20px; padding-bottom: 100px;'>
                    {/* <div class='w-100 d-flex flex-column justify-content-start'>
                        <xmp>{JSON.stringify(user.settings, null, 2)}</xmp>
                    </div> */}
                    {/* <xmp>{JSON.stringify(newCustomer, null, 4)}</xmp> */}
                    <div class='font-weight-lighter px-3 box-header mt-0'>
                        {isNew ? <Text id='product.new'>New product</Text> : <Text id='product.edit'>Edit product</Text>}
                    </div>
                    <div class='bg-light d-flex flex-column justify-content-start pt-3'>
                        <FormFields
                            stores={this.props.stores}
                            sections={sections}
                            holdingStore={productStore}
                            objectName={isNew ? 'newProduct' : 'product'}
                            isNew={isNew}
                            drawerLevel={drawerLevel}
                            hideAdmin={hideAdmin}
                        />
                    </div>


                    <div class='font-weight-lighter px-3 box-header d-flex flex-row justify-content-between mb-1 mt-4'>
                        <Text id='product.related-journal'>Related journal template</Text>
                    </div>
                    <div class={`d-flex flex-column mx-3 px-2 py-2 box-container ${darkmode ? 'bg-darkmode' : 'bg-lightmode'}`}>
                        {product.id ? <>
                            <DyrejournalSaleSearch
                                stores={this.props.stores}
                                key={'journal'}
                                title={journalTitle}
                                holdingStore={journalStore}
                                searchResultList={'searchResults'}
                                searchResultsLine={(e, idx, selectedIndex) => {
                                    return(<>
                                        <div class={`d-flex flex-row justify-content-between px-3 py-1 ${idx === selectedIndex ? 'selected' : ''}`}>
                                            <div>{e?.title} {e?.date}</div>
                                        </div>
                                    </>);
                                }}
                                callback={this.searchJournalCallback}
                                skipSaleUpdate={true}
                                ref={c => this.journalSearchRef = c}
                                // rightButton={hasVisitor && newSaleTItle}
                                // rightButtonClassNames='btn-success'
                                // rightButtonClick={this.onClickNewSale}
                            />
                            <DyrejournalJournalListMini
                                classNames='mx-1'
                                stores={this.props.stores}
                                journals={productJournals}
                                drawerLevel={drawerLevel}
                                // saleIsLocked={saleIsLocked}
                                // animals={[e]}
                                collapse={true}
                                // saveSale={saveSale}
                                viewOnly={true}
                                noSendTo={true}
                            />
                        </> : <>
                            <div class='d-flex flex-row justify-content-between px-3 py-1'>
                                <div><Text id='product.no-product-selected'>No product selected</Text></div>
                            </div>
                        </>}
                    </div>


                    {isNew && <div class='w-100 d-flex flex-column justify-content-start mt-3 px-4 py-3 bg-light fixed-bottom' style={`bottom: 0; left: 0;`}>
                        <button type='button' class='btn btn-primary rounded-pill' onClick={this.createProduct}>
                            {isNew ? <Text id='product.create'>Create product</Text> : <Text id='product.save'>Save product</Text>}
                        </button>
                    </div>}
                </div>
            </div>
        </>);
    }
}

export default NewProduct;
